var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-main"},[_c('div',{staticClass:"main-inner"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1),_c('keep-alive',{attrs:{"include":[]}},[(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }